/** Successful IDB commits only; recovery copies never determine IDB save success. */
const listeners = new Set<() => void>();
export function onLocalDataChanged(listener: () => void) { listeners.add(listener); return () => { listeners.delete(listener); }; }
export function localDataChanged() { for (const listener of listeners) listener(); }
